import React from 'react';

import { FacilitiesListPage } from '../../shared/facilities/FacilitiesListPage';

import { FACILITIES_LIST_QUERY_KEY } from './queryKeys';

export const FacilitiesList: React.FC = () => {
  return (
    <FacilitiesListPage
      queryKeyBase={FACILITIES_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationFacilities"
      showOrganization={false}
    />
  );
};
